import { Component, OnInit, ViewEncapsulation, ViewChild, EventEmitter, Output } from '@angular/core';
import { ClmtlkService } from 'app/clmtlk/shared/service/clmtlk.service';
import { ClmtlkSessionService } from 'app/clmtlk/shared/service/clmtlk-session.service';

@Component({
  selector: 'clmtlk-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FileUploadComponent implements OnInit {

  @ViewChild('clmFileUpload') clmFileUpload;
  files: any[] = [];
  totalNoOfFiles = 0;
  totalSizeOfFiles = 0;
  maxAllowedFileSize = 20000000;
  maxAllowedNoOfFiles = 10;
  validationMsgs: any [];
  @Output() filesList: EventEmitter<any> = new EventEmitter<any>();



  extraFileTypes: any[] = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                          , 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/plain'];

  constructor(private clmtlkService: ClmtlkService,
              private clmtlkSessionService: ClmtlkSessionService) { }

  ngOnInit() {
  }

  uploadFiles() {
    this.clmFileUpload.upload();
  }

  getImageUrl(file) {

    if (file.type.indexOf('video') !== -1) {
      return '/assets/img/vd.png';
    }

    switch (file.type) {

      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return '/assets/img/wd.png';

      case 'application/msword':
      return '/assets/img/wd.png';

      case 'application/vnd.ms-excel':
      return '/assets/img/xl.png';

      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return '/assets/img/xl.png';

      case 'text/plain':
      return '/assets/img/txt.png';

      case 'application/pdf':
      return '/assets/img/pdf.png';

    }

  }

  formatSize = function (bytes) {
      return this.clmFileUpload.formatSize(bytes);
  };

  myUploader(event) {
    console.log('myUploader');
    console.dir(event);
  }

  onSelect(event) {

    this.validationMsgs = [];
    const selectedFiles: any[] = Array.from(event.files);
    let fileSize = this.totalSizeOfFiles;
    selectedFiles.forEach(selectedFile => {
        if (this.isValidFile(selectedFile)) {
          fileSize = fileSize + selectedFile.size;
        }
    });

  if (selectedFiles && selectedFiles.length > 0) {

      if ( selectedFiles.length > 10 || (this.totalNoOfFiles + 1) > this.maxAllowedNoOfFiles ) {
        this.validationMsgs.push({severity: 'error',
                                  summary: 'No of File Exceeded',
                                  detail: `Total number of attached files cannot exceed ${this.maxAllowedNoOfFiles}`});
      }else if ( fileSize > this.maxAllowedFileSize ){
        this.validationMsgs.push({severity: 'error',
                                  summary: 'Total File Size Exceeded',
                                  detail: `Total Size of attachments cannot exceed ${this.formatSize(this.maxAllowedFileSize)}`});
      }else {
        selectedFiles.forEach(selectedFile => {
          if (this.isValidFile(selectedFile)) {
            this.files.push(selectedFile);
            this.totalNoOfFiles ++ ;
            this.totalSizeOfFiles = this.totalSizeOfFiles + selectedFile.size;
          }
        });
      }
    }

    this.filesList.emit(this.files);
  }

  remove(event, i) {
    this.clmFileUpload.remove(event, i);
  }

  isValidFile(file): boolean {

    if (!file.type || file.type === null || file.type === '') {
      return false;
    }

    const accept: string = this.clmFileUpload.accept;
    const acceptTypeArray: string[] = accept.split(',');
    let isValidFile = false;
    acceptTypeArray.forEach(type => {
      const fileTypeArray: string[] = file.type.split('/');
      if (type.indexOf(fileTypeArray[0].toLowerCase()) !== -1 ||
        type.indexOf(fileTypeArray[1].toLowerCase()) !== -1 ) {
          isValidFile = true;
        }
    });

    // For Doc, xls and txt file extensions
    if (this.extraFileTypes.indexOf(file.type) !== -1) {
      isValidFile = true;
    }

    return isValidFile;
  }

  onRemove(event) {
    for (let i = this.files.length - 1; i >= 0; i--) {
      if (this.files[i].name ===  event.file.name && 
        this.files[i].size ===  event.file.size) {
        this.files.splice(i, 1);
        this.totalNoOfFiles--;
        this.totalSizeOfFiles = this.totalSizeOfFiles - event.file.size;
      }
    }

    this.filesList.emit(this.files);
  }


}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/new-message/message-form/file-upload/file-upload.component.ts